import React from 'react';
import { Layout } from 'antd';
import { Link } from 'react-router-dom';
import SthenusLogo from '../../../assets/sthenus-logo.png';
import './Sidebar.css';

const { Sider } = Layout;

const EmptySidebar = ({ collapsed, setCollapsed }) => (
  <Sider
    className="sthenus-sider"
    style={{
      overflow: 'auto',
      height: '100vh',
      position: 'fixed',
      left: 0,
      boxShadow: '2px 0 6px rgba(0,21,41,.35)',
      background: 'var(--sthenus-bg-sidebar)',
    }}
    collapsible
    collapsed={collapsed}
    onCollapse={() => setCollapsed(!collapsed)}
  >
    <h1 className="pointer mb-0" style={{ margin: 0 }}>
      <Link className="sthenus-logo-wrap" to="/" style={{ textDecoration: 'none' }}>
        <img src={SthenusLogo} alt="Sthenus" />
      </Link>
    </h1>
  </Sider>
);

export default EmptySidebar;
